<template>
    <div :class="{ isEmailLogin, displayError }" class="login">
        <div class="login-container">
            <div class="title-container">
                <div class="title-1 bold">{{ $t('login.headline') }}</div>
                <div v-show="state === 'default' || state === 'mail'" class="description copy-s">
                    {{ $t('login.does_not_have_account') }}
                    <span class="link bold" @click="setRegister()">{{ $t('login.register') }}</span>
                </div>
                <div v-show="state === 'register'" class="description copy-s">
                    {{ $t('login.has_account') }}
                    <span class="link bold" @click="setDefault()">{{ $t('login.login') }}</span>
                </div>
            </div>
            <div class="form-container">
                <Button
                    :loading="fbLoading"
                    :value="facebookButtonText"
                    class="facebook-btn"
                    icon="facebook"
                    type="black"
                    @click="loginFacebook"
                />

                <span v-show="state === 'default'" class="action link login-with-mail copy-s" @click="setEmailLogin()">
                    {{ $t('login.register_by_email_instead') }}
                </span>

                <!--                <form
                    v-show="state === 'register'"
                    class="state-group email-register-container"
                    @submit.prevent="login"
                >
                    <div class="separator">
                        <p>oder</p>
                    </div>
                    <div class="row form-element">
                        <label :class="{ error: $v.prename.$error }" class="row-element" for="prename">
                            <input
                                id="prename"
                                ref="prename"
                                v-model="$v.prename.$model"
                                autocomplete="given-name"
                                name="prename"
                                placeholder="Vorname"
                                type="text"
                            />
                            <div v-if="$v.prename.$dirty && !$v.prename.required" class="error copy-s">
                                Vorname ist erforderlich
                            </div>
                        </label>
                        <label :class="{ error: $v.lastname.$error }" class="row-element" for="lastname">
                            <input
                                id="lastname"
                                v-model="$v.lastname.$model"
                                autocomplete="family-name"
                                name="lastname"
                                placeholder="Nachname"
                                type="text"
                            />
                            <div v-if="$v.lastname.$dirty && !$v.lastname.required" class="error copy-s">
                                Nachname ist erforderlich
                            </div>
                        </label>
                    </div>
                    <label :class="{ error: $v.registerEmail.$error }" class="form-element" for="registerEmail">
                        <input
                            id="registerEmail"
                            v-model="$v.registerEmail.$model"
                            autocomplete="email"
                            name="registerEmail"
                            placeholder="Email"
                            type="email"
                        />
                        <div v-if="$v.registerEmail.$dirty && !$v.registerEmail.required" class="error copy-s">
                            E-Mail ist erforderlich
                        </div>
                        <div v-if="!$v.registerEmail.email" class="error copy-s">E-Mail ist nicht gültig</div>
                    </label>

                    <label :class="{ error: $v.registerPassword.$error }" class="form-element" for="registerPassword">
                        <input
                            id="registerPassword"
                            v-model="$v.registerPassword.$model"
                            autocomplete="new-password"
                            name="password"
                            placeholder="Passwort"
                            type="password"
                            @keyup.enter="register"
                        />
                        <div v-if="$v.registerPassword.$dirty && !$v.registerPassword.required" class="error copy-s">
                            Passwort ist erforderlich
                        </div>
                        <div v-if="$v.registerPassword.$dirty && !$v.registerPassword.minLength" class="error copy-s">
                            Passwort muss mindestens {{ $v.registerPassword.$params.minLength.min }} Buchstaben
                            enthalten
                        </div>
                    </label>
                    <div class="checkbox-container">
                        <label for="privacyconsent">
                            <input id="privacyconsent" name="privacyconsent" type="checkbox" />
                            <div class="checkbox">
                                <FeatherIcon name="check" />
                            </div>
                            <span class="copy-s bold">
                                Ich stimme den <a class="link copy-s bold" href="#">Nutzungsbedingungen</a> und
                                <a class="link copy-s bold" href="#">Datenschutzrichtlinien</a> zu
                            </span>
                        </label>
                    </div>
                    <button class="form-element submit button" type="submit" @click="signUpBusinessUser">
                        Registrieren
                    </button>
                </form>-->

                <form v-show="state === 'mail'" class="state-group email-signin-container" @submit.prevent="login">
                    <div class="separator">
                        <p>{{ $t('general.or') }}</p>
                    </div>
                    <label :class="{ error: $v.email.$error }" class="form-element" for="email">
                        <input
                            id="email"
                            ref="emailinput"
                            v-model="$v.email.$model"
                            autocomplete="username"
                            name="email"
                            :placeholder="$t('login.email')"
                            type="email"
                        />
                        <div v-if="$v.email.$dirty && !$v.email.required" class="error copy-s">
                            {{ $t('login.validation.email_required') }}
                        </div>
                        <div v-if="!$v.email.email" class="error copy-s">
                            {{ $t('login.validation.email_invalid') }}
                        </div>
                    </label>

                    <label :class="{ error: $v.password.$error }" class="form-element" for="password">
                        <input
                            id="password"
                            v-model="$v.password.$model"
                            autocomplete="current-password"
                            name="password"
                            :placeholder="$t('login.password')"
                            type="password"
                            @keyup.enter="login"
                        />
                        <div v-if="$v.password.$dirty && !$v.password.required" class="error copy-s">
                            {{ $t('login.validation.password_required') }}
                        </div>
                        <div v-if="$v.password.$dirty && !$v.password.minLength" class="error copy-s">
                            {{
                                $t('login.validation.password_min_length', {
                                    minLength: $v.password.$params.minLength.min,
                                })
                            }}
                        </div>
                    </label>
                    <button class="form-element submit button" type="submit" @click="login">
                        <span v-show="!loading" class="copy-m bold">
                            {{ $t('login.login') }}
                        </span>
                        <DLoader v-show="loading" />
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { email, minLength, required } from 'vuelidate/lib/validators'
import Button from '@/components/Button'
import DLoader from '@/components/DLoader'

export default {
    name: 'Login',
    components: {
        Button,
        DLoader,
    },
    data() {
        return {
            email: '',
            password: '',
            prename: '',
            lastname: '',
            registerEmail: '',
            registerPassword: '',
            state: 'default',
            isEmailLogin: false,
            skipQuery: true,
            displayError: false,
            loading: false,
            fbLoading: false,
        }
    },
    validations: {
        email: {
            required,
            email,
        },
        password: {
            required,
            minLength: minLength(2),
        },
        prename: {
            required,
        },
        lastname: {
            required,
        },
        registerEmail: {
            required,
            email,
        },
        registerPassword: {
            required,
            minLength: minLength(8),
        },
    },
    computed: {
        buttonType() {
            return this.formValid ? 'yellow' : 'disabled'
        },
        facebookButtonText() {
            return this.state === 'register'
                ? this.$t('login.sign_up_with_facebook')
                : this.$t('login.continue_with_facebook')
        },
        formValid() {
            return !this.$v.email.$invalid && !this.$v.password.$invalid
        },
    },
    methods: {
        async signUpBusinessUser() {
            const payload = {
                vm: this,
                email: this.registerEmail,
                password: this.registerPassword,
                firstName: this.prename,
                lastName: this.lastname,
            }
            const res = await this.$store.dispatch('signUpBusinessUser', payload)

            if (res) {
                await this.$router.push({ name: 'venues' }).catch((e) => {
                    console.log('error', e)
                })
            }
        },
        async signUpFacebookBusinessUser(token) {
            this.fbLoading = true
            const payload = {
                vm: this,
                token,
            }
            const res = await this.$store.dispatch('signUpFacebookBusinessUser', payload)

            if (res) {
                await this.$router.push({ name: 'venues' }).catch((e) => {
                    console.log('error', e)
                })
            }
            this.fbLoading = false
        },
        async loginFacebook() {
            this.fbLoading = true
            if (window.FB) {
                await window.FB.login(
                    async (res) => {
                        if (res && res['status'] === 'connected') {
                            await this.signUpFacebookBusinessUser(res['authResponse'].accessToken)

                            await this.$router.push({ name: 'venues' }).catch((e) => {
                                console.log('error', e)
                            })
                        }
                    },
                    { scope: 'email, pages_show_list' },
                )
            } else {
                console.error('fb-sdk undefined')
            }
            this.fbLoading = false
        },
        setRegister() {
            this.state = 'register'
            setTimeout(() => {
                this.$refs['prename'].focus()
            }, 1)
        },
        setEmailLogin() {
            this.state = 'mail'
            setTimeout(() => {
                this.$refs['emailinput'].focus()
            }, 1)
        },
        setDefault() {
            this.state = 'default'
        },
        async getCurrentUser() {
            this.$apollo.queries.signedInUser.skip = false
            return await this.$apollo.queries.signedInUser.refetch()
        },
        async login() {
            this.loading = true
            if (this.formValid) {
                const data = {
                    vm: this,
                    email: this.email,
                    password: this.password,
                }

                try {
                    const res = await this.$store.dispatch('login', data)

                    if (res) {
                        await this.$router.push({ name: 'venues' }).catch((e) => {
                            console.log('error', e)
                        })
                    } else {
                        this.displayError = true
                    }
                } catch (e) {
                    return false
                }
            }

            this.loading = false
            return false
        },
    },
}
</script>

<style lang="sass" scoped>
.login
    display: flex
    justify-content: center
    font-weight: bold

    .link
        color: black

        &:hover
            cursor: pointer
            text-decoration: underline

    .loader-container
        height: 50px
        display: grid
        place-items: center

    &.displayError
        input
            box-shadow: 0 0 0 2px $red !important


    .login-container
        display: flex
        flex-direction: column
        align-items: center

        @include breakpoint('m')
            padding: 24px
            border-radius: 1rem
            box-shadow: $box-mois
            margin: 16px
            width: 100%
            background-color: $neutral-white

        .title-container
            flex-direction: column

            .title-1
                color: black
                margin-bottom: $xs
                font-size: 36px
                line-height: 59.4px

            .description
                .link
                    color: black
                    cursor: pointer


    .form-container
        max-width: 32.7em
        width: 100%
        display: flex
        margin-top: $l
        flex-direction: column

        .row
            display: flex

            .row-element
                margin-top: 0

            .row-element + .row-element
                margin-left: $s

        .action
            margin-top: $s
            cursor: pointer

        .facebook-btn
            &::v-deep
                .feather-icon
                    svg
                        fill: white
                        stroke: none


        form
            .form-element + .form-element
                margin-top: $s


        .submit
            cursor: pointer

        .error
            color: $red
            margin-top: 0

            &.main
                margin-bottom: $m

        .button
            border-radius: 10px
            display: inline-flex
            align-items: center
            justify-content: center
            height: 4rem
            cursor: pointer
            outline: none
            +transition(80ms)
            white-space: nowrap
            font-weight: bold

            &.submit
                border: none
                box-shadow: none
                background: #FEC400

                .d-loader
                    width: 20px
                    height: 20px

                .copy-m
                    color: black

                &::v-deep svg
                    stroke: black

                &:hover, &:focus
                    background: lighten(#FEC400, 5%)


        .state-group
            z-index: 1
            display: flex
            justify-content: center
            flex-direction: column

            .error
                margin-top: $xs
                margin-bottom: $xxs
                text-align: left
                color: $red


            .checkbox
                width: 16px
                min-width: 16px
                height: 16px
                min-height: 16px
                border-radius: 4px
                background: $gray-1
                display: flex
                align-items: center
                justify-content: center
                margin-right: $s

                .feather-icon
                    width: 12px
                    height: 12px
                    transform: scale(0)
                    +transition(50ms)

                    &::v-deep
                        svg
                            stroke: white


            .checkbox-container
                margin: $l 0

                label
                    display: flex

                    .copy-s
                        text-align: left

                input[type=checkbox]
                    appearance: none
                    display: none

                    &:checked ~ .checkbox
                        background: $primary-2

                        .feather-icon
                            transform: scale(1)


            label

                &.error
                    input
                        box-shadow: 0 0 0 2px $red

                input
                    background: $gray-2
                    border-radius: 10px
                    width: 100%
                    padding: $xs $m
                    color: black
                    border-color: transparent
                    outline: none
                    box-sizing: border-box

                    &:focus
                        box-shadow: 0 0 0 2px $primary-1


    .separator
        height: 18px
        display: flex
        justify-content: center
        align-items: center
        margin: $m 0

        &::before, &::after
            content: ""
            width: 100%
            height: 1px
            top: 26%
            left: 0
            background: $neutral-2

        p
            text-align: center
            z-index: 1
            color: $neutral-3
            padding: 0 $xs


//
</style>
